export default {
  short_description: '¡Ahorra tiempo y gana recompensas!',
  full_description:
    'La app {{name}} ya está aquí – para pedir con aún más facilidad:\n\n• Pedidos ultrarrápidos desde la app\n\n• Notificaciones inmediatas sobre promociones y recompensas\n\n• Acumula y canjea tus puntos fácilmente\n\n• Sigue el estado de tu pedido en tiempo real\n\n¡Estamos encantados de ofrecerte nuestra app y esperamos que la disfrutes tanto como nosotros!`',
};
